import React from 'react';
import { Link } from 'gatsby';

import '../../styles/scss/style.scss';


export const Hero = () => {
  return (
          <div className="hero animated bounce" style={{ marginTop:"10rem" }}>
            <div className="feature__wrap">
              <div className="feature__left">
                <h3 className="feature__lead feature__lead--1 showcase__lead text-left">
                  Consistency in Design
                </h3>
                <p className="feature__text">
                  Loop pro x makes it possible to keep your designs consistent and unique across all platforms. You dont need to rethink your design each time when designing another mockup and you can easily edit your designs while still being consistent
                </p>
          <br />

                    <Link
                      className="btn1 btn__inverse"
                      to="#pricing"
                    >
                      Get Loop Pro X
                    </Link>
              </div>
              <div className="feature__right">
                <img
                  src={require('../../components/images/loopconsis.png')}
                  alt="#"
                  className="feature__img"
                  
                />
              </div>
            </div>

          </div>
  );
};
